import { cnpjMask, cpfMask, isCPF } from './utils';

export const DocumentNumber = ({ number }) =>
  isCPF(number) ? cpfMask(number) : cnpjMask(number);
